<template>
  <div class="container">
    <img id="homeBg" src="../assets/home/homeBg.png" alt="" />
    <div class="titleContainer">
      <p>欢迎进入</p>
      <p>科飞视觉智能评估<span style="opacity: 0">®</span></p>
    </div>
    <div class="descriptionContainer">
      <p>
        本系统基于中国科学技术大学视觉研究实验室研发的视知觉技术及国际通用视觉健康量表技术开发。能为您提供视觉质量的相对评估和评价。
      </p>
      <div>
        <!-- <p>评估分为两部分：</p> -->
        <!-- <p>（1）视觉健康问卷-对视觉健康问题进行定性分析。共X道题，预计3分钟。</p> -->
        <!-- <p>（2）视知觉能力测试-对视知觉功能进行相对定量评估。预计10分钟左右。</p> -->
        <p>视知觉能力测试-对视知觉功能进行相对定量评估。预计10分钟左右。</p>
      </div>
    </div>
    <div class="btnsContainer">
      <div class="btnStartAssessment" @click="onStartAssessment">开始评估</div>
      <!-- <div class="btnSkipAssessment" @click=onSkipAssessment>
                跳过问卷
            </div> -->
    </div>
    <p id="footerP">
      本系统提供的评估报告不能代表专业的医疗建议、诊断或治疗，如果您有任何个人医疗问题，或者发现有冲突的信息，建议您咨询专业医生。
    </p>
    <div id="imgContainer" v-if="isShow">
      <img id="showImg" src="../assets/common/tip.png" alt="" />
      <p>您准备好了吗，让我们开始吧！</p>
      <div class="btnNext" @click="onNext">下一步</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {
      isShow: false,
    };
  },
  methods: {
    //开始评估
    onStartAssessment() {
      if (this.$store.state.global.isLoadingShow) {
        return;
      }
      //判断有没有填写过信息
      // if(this.$store.state.global.personalInformationBol){
      //     this.$router.push('/questionnaire')
      // }
      // else{
      //     this.$router.push('/personalInformation')
      // }
      this.$store.state.global.isSkip = true;
      this.$router.push("/phone");

      // this.isShow=true
    },
    //跳过评估
    onSkipAssessment() {
      if (this.$store.state.global.isLoadingShow) {
        return;
      }
      this.$store.state.global.isSkip = true;
      if (this.$store.state.global.personalInformationBol) {
        this.$router.push("/commonDescription");
      } else {
        this.$router.push("/personalInformation");
      }
    },
    onNext() {
      if (this.$store.state.global.isFirst) {
        this.$store.state.global.itemNum = 1;
      } else {
        this.$store.state.global.itemNum = 0;
      }

      if (this.$store.state.global.personalInformationBol) {
        this.isShow = false;
        this.$router.push("/commonDescription");
      } else {
        this.$router.push("/personalInformation");
      }
    },
  },
  mounted() {
    this.$store.state.global.isSkip = false;
    this.$store.state.global.isTrans = false;
  },
};
</script>

<style scoped>
#imgContainer p {
  position: absolute;
  left: 50%;
  top: 85%;
  transform: translate(-50%, 0%);
  font-size: 3vw;
  white-space: nowrap;
}
#imgContainer {
  width: 100%;
  height: 100%;
  background: rgb(255, 255, 255);
  position: relative;
}
#showImg {
  position: absolute;
  width: 100%;
}
.btnNext {
  background: rgb(1, 220, 195);
  color: rgb(255, 255, 255);
  position: absolute;
  width: 30vw;
  border-radius: 2vw;
  height: 10vw;
  text-align: center;
  line-height: 10vw;
  font-size: 4vw;
  left: 35vw;
  top: 90%;
}
.titleContainer {
  position: absolute;
  left: 50%;
  /* top:8%; */
  top: 3%;
  transform: translate(-50%, 0%);
}
.titleContainer p {
  width: 100vw;
  color: white;
  padding-top: 3vw;
  text-align: center;
  font-size: 6vw;
}
.descriptionContainer {
  position: absolute;
  left: 50%;
  top: 20%;
  /* top:20%; */
  transform: translate(-50%, 0%);
}
.descriptionContainer p {
  color: white;
  width: 80vw;
  font-size: 3vw;
  line-height: 6vw;
}
.descriptionContainer div {
  padding-top: 1vw;
}
.btnsContainer {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 50%;
  top: 80%;
  transform: translate(-50%, 0%);
}
.btnsContainer div {
  width: 80vw;
  height: 11vw;
  border-radius: 5vw;
  text-align: center;
  line-height: 11vw;
  font-size: 4vw;
}
.btnStartAssessment {
  background: rgb(255, 246, 0);
  color: rgb(51, 51, 51);
}
.btnSkipAssessment {
  background: rgb(2, 190, 255);
  color: rgb(255, 255, 255);
  margin-top: 3vw;
}
#homeBg {
  position: absolute;
  top: 0%;
  left: 0;
  width: 100%;
  height: 100%;
}
#footerP {
  width: 95vw;
  font-size: 2vw;
  color: white;
  position: absolute;
  left: 50%;
  top: 95%;
  transform: translate(-50%, -50%);
  line-height: 5vw;
  text-align: center;
}
</style>
